/* Play button overlay for YouTube feed items. Opens the YouTube viewer. */

import { Play } from "lucide-react";
import { useVideoPlayer } from "@/hooks/useVideoPlayer";
import type { VideoTrack } from "@/types/videoPlayer";

interface YouTubePlayButtonProps {
  track: VideoTrack;
}

export function YouTubePlayButton({ track }: YouTubePlayButtonProps) {
  const { state, open } = useVideoPlayer();
  const isThisTrack = state.track?.feedItemId === track.feedItemId;

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    open(track);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      onMouseDown={(e) => e.stopPropagation()}
      className="absolute inset-0 flex items-center justify-center bg-black/40 rounded-sm opacity-0 group-hover:opacity-100 hover:opacity-100 transition-opacity"
      style={isThisTrack ? { opacity: 1 } : undefined}
    >
      <div className="size-10 rounded-full bg-primary/90 flex items-center justify-center shadow-md">
        <Play className="size-5 text-primary-foreground fill-current ml-0.5" />
      </div>
    </button>
  );
}
